module.exports = __webpack_public_path__ + "media/luxury-2026/twilight-drone-0102f145.jpg";